export var TopnavEvents;
(function (TopnavEvents) {
    TopnavEvents["next"] = "sermonshots-next-step";
    TopnavEvents["previous"] = "sermonshots-previous-step";
    TopnavEvents["disabledNext"] = "sermonshots-disabled-next";
    TopnavEvents["disabledPrevious"] = "sermonshots-disabled-previous";
    TopnavEvents["customEvent"] = "sermonshots-topnav-custom-event";
    TopnavEvents["download"] = "sermonshots-download-step";
    TopnavEvents["saveProject"] = "sermonshots-save-project";
})(TopnavEvents || (TopnavEvents = {}));
export let topnavEventCallbacks = {
    next: (e) => { },
    previous: (e) => { },
    disabledNext: (e) => { },
    disabledPrevious: (e) => { },
    download: (e) => { },
    saveProject: (e) => { },
    customEvent: (e) => { }
};
window.addEventListener(TopnavEvents.disabledNext, e => topnavEventCallbacks.disabledNext(e));
window.addEventListener(TopnavEvents.disabledPrevious, e => topnavEventCallbacks.disabledPrevious(e));
window.addEventListener(TopnavEvents.next, e => topnavEventCallbacks.next(e));
window.addEventListener(TopnavEvents.previous, e => topnavEventCallbacks.previous(e));
window.addEventListener(TopnavEvents.download, e => topnavEventCallbacks.download(e));
window.addEventListener(TopnavEvents.saveProject, e => topnavEventCallbacks.saveProject(e));
export const topnav = {
    disabledNext: function (callback) {
        topnavEventCallbacks.disabledNext = callback;
        // return () => window.removeEventListener(TopnavEvents.disabledNext, callback);
    },
    disabledPrevious: function (callback) {
        topnavEventCallbacks.disabledPrevious = callback;
        // return () => window.removeEventListener(TopnavEvents.disabledPrevious, callback);
    },
    next: function (callback) {
        topnavEventCallbacks.next = callback;
        // return () => window.removeEventListener(TopnavEvents.next, callback);
    },
    previous: function (callback) {
        topnavEventCallbacks.previous = callback;
        // return () => window.removeEventListener(TopnavEvents.previous, callback);
    },
    download: function (callback) {
        // window.addEventListener(TopnavEvents.download, callback);
        topnavEventCallbacks.download = callback;
        // return () => window.removeEventListener(TopnavEvents.download, callback);
    },
    saveProject: function (callback) {
        // window.addEventListener(TopnavEvents.saveProject, callback);
        topnavEventCallbacks.saveProject = callback;
        // return () => window.removeEventListener(TopnavEvents.saveProject, callback);
    },
    dispatchEvent: function (detail) {
        window.dispatchEvent(new CustomEvent(TopnavEvents.customEvent, { detail }));
    }
};
